export const TargetingType = {
  AllSettings: 0,
  Locations: 1,
  AdSchedule: 2,
  Devices: 3,
};

export const DeviceName = {
  Computers: 'Computers',
  Tablets: 'Tablets',
  Smartphones: 'Smartphones',
};

export const TargetingScope = {
  Account: 0,
  Campaign: 1,
  AdGroup: 2,
};

export const TargetingScopeLiterals = [
  'account',
  'campaign',
  'adgroup',
];

export const TargetingLevel = {
  Campaign: 0,
  AdGroup: 1,
};

export const TargetingLevelLiterals = [
  'campaign',
  'adgroup',
];

export const TargetingRoutes = [
  {
    allSettings: 'campaign_allsettings',
    settings: 'campaign_settings',
  },
  {
    allSettings: 'campaign_edit',
    settings: 'campaign_edit_settings',
  },
  {
    allSettings: 'adgroup_edit',
    settings: 'adgroup_edit_settings',
  },
];

export const TabItems = [
  {
    name: 'allSettings',
    text: 'TargetingSettings_All',
    value: TargetingType.AllSettings,
    routeParams: {},
  },
  {
    name: 'locations',
    text: 'TargetingSettings_Locations',
    value: TargetingType.Locations,
    routeParams: { setting: 'locations' },
  },
  {
    name: 'adSchedule',
    text: 'TargetingSettings_AdSchedule',
    value: TargetingType.AdSchedule,
    routeParams: { setting: 'adschedule' },
  },
  {
    name: 'devices',
    text: 'TargetingSettings_Devices',
    value: TargetingType.Devices,
    routeParams: { setting: 'devices' },
  },
];
